import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Form, Accordion } from 'react-bootstrap';
import { LiaShippingFastSolid } from "react-icons/lia";
import { MdOutlineZoomOutMap, MdOutlineDescription } from "react-icons/md";
import { IoIosReturnLeft } from "react-icons/io";
import { BsBagCheckFill, BsTruck, BsGeoAltFill } from 'react-icons/bs';
import { FaCartPlus } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getProductByName } from '../../../redux/productSlice';
import { getProductRating } from "../../../redux/reviewSlice";
import { addToCart } from "../../../redux/cartSlice";
import { createOrder, verifyPayment } from "../../../redux/paymentSlice";
import ReviewList from '../Review/Review';
import ProductModal from '../../common/ProductModal/ProductModal';
import Star from "../../common/Star/Star";
import { toast } from 'react-toastify';

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const { slug } = useParams();
  if (process.env.NODE_ENV === "development") {
    console.log("slug", slug);
  }
  const { products, loading, error } = useSelector(state => state.products);
  const product = products?.product || {}; // Ensure safe data access
  if (process.env.NODE_ENV === "development") {
    console.log("product rest", product);
  }
  const [rating, setRating] = useState(0);
  const [image, setImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  const [details, setDetails] = useState(null);
  if (process.env.NODE_ENV === "development") {
    console.log("details", details);
  }

  const ratings = useSelector((state) => state.review.ratings);
  if (process.env.NODE_ENV === "development") {
    console.log("product", product?._id);
    console.log("avdhesh", ratings[product?._id]);
  }

  useEffect(() => {
    dispatch(getProductByName(slug)).then((response) => {
      setDetails(response.payload);
    });
  }, [dispatch, slug]);

  useEffect(() => {
    if (details && details.images && details.images.length > 0) {
      setImage(`${apiUrl}${details.images[0]}`);
    }
  }, [details, apiUrl]);


  const getProductAverageRating = useCallback(async (productId) => {
    try {
      await dispatch(getProductRating(productId));
    } catch (error) {
      toast.error("Error fetching product rating:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    getProductAverageRating(details?._id);
  }, [getProductAverageRating, details?._id]);

  const handleAddToCart = useCallback(async (product) => {
    if (process.env.NODE_ENV === "development") {
      console.log("product++", product);
    }
    try {
      await dispatch(addToCart({ items: [{ product: product, quantity: 1 }] }));
      toast.success(`${product} added to cart successfully!`);
    } catch {
      toast.error(`Failed to add ${product.name} to cart.`);
    }
  }, [dispatch]);

  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
      <Spinner animation="border" />
    </div>
  );
  if (error) return <h3 className="text-danger">{error}</h3>;


  const getImageUrl = (image, index) => {
    const imageUrl = `${apiUrl}${image}`;
    setImage(imageUrl);
    setSelectedImageIndex(index); // Track selected image
  }
  function handleShow() {
    setShow(true);
  }
  const getRemainingTime = (day) => {
    const today = new Date();
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + day);

    return futureDate.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit'
    });
  };

  const handlePayment = async (details) => {
    try {
      if (process.env.NODE_ENV === "development") {
        console.log("handlePayment details", details);
      }
      const amount = details.price; // Razorpay expects amount in paise (for INR)

      const response = await dispatch(createOrder(amount));
      const orderData = response.payload.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: amount,
        currency: details.currency,
        name: 'My Store',
        description: 'Payment',
        order_id: orderData.id, // assuming backend returns Razorpay order ID here
        handler: async (razorpayResponse) => {
          if (process.env.NODE_ENV === "development") {
            console.log("handlePayment response:", razorpayResponse);
          }
          await dispatch(verifyPayment(razorpayResponse));
          toast.success("Payment Successful");
          alert('Payment Successful');
        },
        prefill: {
          name: 'Test User',
          email: 'sonu@gmail.com',
          contact: '9891897353',
        },
        theme: { color: '#3399cc' },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error("Please Login Again. Session has been Expired", error);
      // toast.error("Payment failed. Please try again.");
    }
  };


  return (
    <Container className="mt-4">
      <Row>
        <Col md={12} className="text-left">
        </Col>
      </Row>

      <Row className="mt-4 justify-content-center">
        <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2, }} md={{ span: 12, order: 2, }} lg={{ span: 1, order: 1 }} xl={{ span: 1, order: 1 }} xxl={{ span: 1, order: 1 }} >
          <ul className="list-images">
            {details?.images && details?.images.map((image, index) => (
              <li key={index}
                className={selectedImageIndex === index ? "active" : ""}
                onClick={() => getImageUrl(image, index)}
              >
                <img
                  src={`${apiUrl}${image}`}
                  alt={`Image ${index + 1}`}
                  className="img-fluid"
                />
              </li>
            ))}
          </ul>
        </Col>
        <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1, }} md={{ span: 12, order: 1, }} lg={{ span: 5, order: 2 }} xl={{ span: 5, order: 2 }} xxl={{ span: 5, order: 2 }}>
          <Card className="position-relative">
            <MdOutlineZoomOutMap color="#fff" cursor="pointer" size={30} onClick={() => handleShow()} className="top-0 mt-2 position-absolute end-0 me-2" />
            <Card.Img
              variant="top"
              src={image || 'placeholder-image-url'}
              alt={details?.name || 'Product Image'}
            />
          </Card>
        </Col>
        <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 3, }} md={{ span: 12, order: 3, }} lg={{ span: 6, order: 3 }} xl={{ span: 6, order: 3 }} xxl={{ span: 6, order: 3 }}>
          <Row>
            <Col lg={12}>
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title>{details?.name}</Card.Title>
                  <Card.Text>
                    <Star value={details?.averageRating} alignLeft="left" reviewTotalCount={details?.ratings?.length} style={{ fontSize: "24px" }} />
                  </Card.Text>
                  {/* <Card.Text>{details?.description}</Card.Text> */}
                  <h4 className="text-success"><span>₹{details?.price}</span><span className="custom-line-through">₹{details?.mrpPrice}</span> <span className="custom-card-discount">({details?.discountPercent}% OFF)</span></h4>
                  <h4 className="fs-6">Discount Applied | Hurry Up 🥳</h4>
                  <div className="mt-3 d-flex justify-content-space-between align-items-center gap-3">
                    <Button variant="primary" className="mt-3 custom-button" disabled={!details?.name} onClick={() => handleAddToCart(details?._id)}>
                      <FaCartPlus size={20} /> Add to Cart
                    </Button>

                    <Button variant="primary" className="mt-3 custom-button" disabled={!details?.name} onClick={() => handlePayment(details)}>
                      Buy Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <h5 className="p-3 mb-3 text-center border">Estimated Delivery Date : <strong>{getRemainingTime(5)} ~ {getRemainingTime(7)}</strong></h5>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ul className="delivery-timeline">
                <li>
                  <div className="mb-2">
                    <div className="text-white delivery-timeline__icon bg-dark rounded-circle d-inline-flex justify-content-center align-items-center" style={{ width: 50, height: 50 }}>
                      <BsBagCheckFill size={20} />
                    </div>
                  </div>
                  <h6><strong>Order Now</strong></h6>
                  <p className="text-decoration-underline">{getRemainingTime(0)}</p>
                </li>
                <li>
                  <div className="mb-2">
                    <div className="text-white delivery-timeline__icon bg-dark rounded-circle d-inline-flex justify-content-center align-items-center" style={{ width: 50, height: 50 }}>
                      <BsTruck size={20} />
                    </div>
                  </div>
                  <h6><strong>Order Dispatch</strong></h6>
                  <p className="text-decoration-underline">{getRemainingTime(0)} - {getRemainingTime(2)}</p>
                </li>
                <li>
                  <div className="mb-2">
                    <div className="text-white delivery-timeline__icon bg-dark rounded-circle d-inline-flex justify-content-center align-items-center" style={{ width: 50, height: 50 }}>
                      <BsGeoAltFill size={20} />
                    </div>
                  </div>
                  <h6><strong>Delivered</strong></h6>
                  <p className="text-decoration-underline">{getRemainingTime(5)} - {getRemainingTime(7)}</p>
                </li>
              </ul>
            </Col>

          </Row>
          <Row>
            <Col lg={12}>
              <h1 className="details-rerturn">
                1 Year Warranty
                <strong>7 Day Easy Return</strong></h1>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="mt-3">
              <Accordion defaultActiveKey={['0']} alwaysOpen>
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="custom-accordion"><MdOutlineDescription size={25} className="me-2" /> Product Details</Accordion.Header>
                  <Accordion.Body>
                    <p>{details?.description}</p>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header className="custom-accordion"><LiaShippingFastSolid size={25} className="me-2" /> Shipping</Accordion.Header>
                  <Accordion.Body>
                    <p>For Prepaid Orders: We charge no shipping and handling fee. Free shipping for all prepaid orders.</p>
                    <p>For most serviceable pin codes, we try to deliver within 7 days. But due to unforeseen circumstances like whether strikes, remote locations, stocking issues, or any other reason - it may take longer. You will however be able to track your package using a unique tracking link that we will email/SMS you after your order is sent to our delivery partner.</p>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2" alwaysOpen>
                  <Accordion.Header className="custom-accordion"><IoIosReturnLeft size={25} className="me-2" />Return Policy</Accordion.Header>
                  <Accordion.Body>
                    <p>We have a 7 day return policy, which means you have 7 days after receiving your item to request a return.</p>
                    <p>To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.</p>
                    <p>Return is only accepted for damage product or different product</p>
                    <p>Size return and refund not available</p>
                    <p className="fw-bold">- REPLACEMENTS WILL ONLY BE ISSUED AFTER INSPECTION</p>
                    <p className="fw-bold">- UNBOXING VIDEO IS A MUST TO INITIATE A RETURN</p>
                    <p>To start a return, you can contact us at <span className="fw-bold">avdhesh@gmail.com.</span> Please note that returns will need to be sent to the following address: [INSERT RETURN ADDRESS]</p>
                    <p>If your return is accepted, we’ll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted.</p>
                    <p>You can always contact us for any return question at <span className="fw-bold">avdhesh@gmail.com</span>.</p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <ReviewList productId={details?._id} />
        </Col>
      </Row>

      <ProductModal
        handleShow={handleShow}
        values={values}
        product={details}
        fullscreen={fullscreen}
        show={show}
        setShow={setShow}
      />
    </Container >
  );
};

export default ProductDetails;
